import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { getUvid } from '@/utils/uvid'
import { getFid } from '@/utils/fid'
import { getQuery } from '@/utils/utils'
import { globalVariable } from '@/utils/exportVariable'
import { storage, fissionGuest2OwnerInfos } from '@/utils/storage'
import { stringToJson } from '@/utils/tool'
import { getServerHost } from '@/utils/host'

function commonParams() {
  return {
    uvid: getUvid(),
    fid: getFid(),
  }
}

// 兑换接口
export function exchange(options) {
  options = {
    ...options,
    ...commonParams(),
  }
  return request.postJson({
    url: appendApiUrl('/activity/user/exchange'),
    data: { ...deleteEmpty(options) },
  })
}

// 记录用户裂变关系

export function setRelation(options) {
  return request.postJson({
    url: appendApiUrl('/activity/save/relation'),
    data: { ...deleteEmpty(options) },
  })
}

// 兑换记录裂变

export function exchangeRecordList(options) {
  return request.postJson({
    url: appendApiUrl('/activity/user/query/exchange'),
    data: { ...deleteEmpty(options) },
  })
}

// 分享接口
export function userShare(options) {
  options = {
    ...options,
    ...commonParams(),
  }
  return request.postJson(
    {
      url: appendApiUrl('/activity/user/share'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
    }
  )
}

// 兑换商品查询

export function exchangeSKu(options) {
  return request.postJson({
    url: appendApiUrl('/activity/query/exchange-sku'),
    data: { ...deleteEmpty(options) },
  })
}
// 查询活动下用户积分总数

export function getUserPoints(options = {}) {
  return request.postJson(
    {
      url: appendApiUrl('/activity/user/query/points'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

// 查询用户活动(裂变)进度(新注册、首付费)

export function getUserProgress(options) {
  return request.postJson({
    url: appendApiUrl('/activity/user/query/progress'),
    data: { ...deleteEmpty(options) },
  })
}

// 活动(裂变)配置信息查询

export function getActivityList(options, ssrLocationParams) {
  return request
    .postJson(
      {
        baseURL: ssrLocationParams && getServerHost(ssrLocationParams),
        url: appendApiUrl('/activity/query/list'),
        data: { ...deleteEmpty(options) },
      },
      {
        showErrorToast: false,
      }
    )
    .then((res) => {
      // 兼容处理：将 activityId 转换为字符串类型，确保与代码中其他地方的字符串类型定义兼容
      if (Array.isArray(res)) {
        return res.map((item) => {
          if (item && typeof item.activityId !== 'undefined') {
            return {
              ...item,
              activityId: String(item.activityId),
            }
          }
          return item
        })
      }
      return res
    })
}
// 优惠券信息查询
export function getCouponList(options) {
  return request.postJson(
    {
      url: appendApiUrl('/activity/query/coupon/list'),
      data: { ...deleteEmpty(options) },
    },
    {
      showErrorToast: false,
    }
  )
}

// 获取裂变的参数：被分享者携带的分享者的裂变活动参数
export function getFissionParams(type) {
  if (!process.client) {
    return {}
  }
  // 从query中取
  const query_activityId = getQuery('activityId')
  const query_attachedKicoinId = getQuery('attachedKicoinId')
  if (query_activityId && query_attachedKicoinId) {
    return {
      activityId: query_activityId,
      attachedKicoinId: query_attachedKicoinId,
    }
  }
  // 从store中取
  const { fissionGuestInfos = {} } = globalVariable?.store?.state || {}
  const { attachedKicoinId, activityId } = fissionGuestInfos || {}
  const store_activityId = activityId
  const store_attachedKicoinId = attachedKicoinId
  if (store_activityId && store_attachedKicoinId) {
    return {
      activityId: store_activityId,
      attachedKicoinId: store_attachedKicoinId,
    }
  }
  // 从localstorage中取
  const { attachedKicoinId: mid, activityId: aid } = getCacheFissionDatas(type)
  if (mid && aid) {
    return {
      activityId: aid,
      attachedKicoinId: mid,
    }
  }
  return {}
}

function getCacheFissionDatas(type) {
  const { region, fissionGame } = globalVariable?.store?.state || {}
  const cacheDatas =
    type === 'vk'
      ? vkLoginFissionDatas()
      : storage.get(fissionGuest2OwnerInfos + '_' + region + '_' + fissionGame)

  const { activityId, attachedKicoinId, time } = cacheDatas || {}
  const curTs = +new Date()
  const timeDiff = curTs - time
  const isMoreOneHour = timeDiff - 60 * 60 * 1000
  if (isMoreOneHour > 0) {
    return {}
  } else {
    return {
      activityId,
      attachedKicoinId,
    }
  }
}
// 修复vk登录时携带裂变参数
// 由于vk登录是使用重定向的方式，在来回跳转加载的过程中存储在内存中的数据会丢失，只能在获取localStorage中的数据
// 此时不知道是哪个裂变游戏，只能将裂变相关的数据都拿出来，按照最新时间得出结果
function vkLoginFissionDatas() {
  const len = window.localStorage.length
  const res = []
  for (let i = 0; i < len; i++) {
    const key = window.localStorage.key(i)
    if (key && key.indexOf('@@ks-fission-guest2Owner-infos') > -1) {
      res.push(window.localStorage.getItem(key))
    }
  }
  if (res.length > 0) {
    // 只有一个
    if (res.length === 1) {
      return stringToJson(res[0])
    } else {
      // 多个时，按照存储时间排序，取最新时间
      const formatRes =
        res.map((item) => stringToJson(item)).sort((a, b) => b.time - a.time) ||
        []
      return formatRes[0]
    }
  }
  return {}
}

// 获取用户信息
export function getUserInfo(kicoinId) {
  return request.get({
    url: appendApiUrl(`/user/info?kicoinId=${kicoinId}`),
  })
}
